// @flow
import React from "react";
import { Box, Button, Control, Input, Toast } from "biologiatotal-ui";
import "./loginForm.scss";
import Form from "../../../components/form";

import formSchema from "./schema";
import { Link } from "react-router-dom";

class LoginForm extends Form {
  constructor(props) {
    super(props, formSchema);

    this.state = {
      ...this.state
    };
    this.doLogin = this.doLogin.bind(this);
  }

  doLogin = async event => {
    if (event) {
      event.preventDefault();
    }

    const { onLogin } = this.props;

    this.validate()
      .then(
        () => onLogin(this.getValues()),
        () => null
      )
      .then(
        () => null,
        () => {
          Toast.error(
            <div>
              <b>O login ou a senha estão incorretos!</b>
              <br />
              Verifique as informações e tente novamente.
            </div>
          );
          this.setState({
            errors: {
              email: " ",
              password: " "
            }
          });
        }
      );
  };

  handleKeyPress = event => {
    if (event.key === "Enter") {
      this.doLogin();
    }
  };

  render() {
    const { showLoginButton, isLogging, className = "" } = this.props;
    const { values, errors } = this.state;

    return (
      <div className={`columns login-panel ${className}`}>
        <div className="column centered is-12-mobile is-8-tablet is-6-desktop is-4-widescreen is-offset-2-tablet is-offset-3-desktop is-offset-4-widescreen">
          <Box className="login-panel-content">
            <div className="login-panel-header">
              <span>BEM-VINDO DE VOLTA</span>
            </div>
            <div>
              <span className="login-panel-header-texttwo">Insira os seus dados para acessar a plataforma</span>
            </div>
            <form>
              <div className="login-panel-form">
                <Control className="logininput login-form-control">
                  <span className="login-form-label">Seu e-mail:</span>
                  <Input
                    className="login-form-input"
                    aria-label="Login"
                    placeholder="Login"
                    type="email"
                    danger={!!errors.email}
                    value={values.email}
                    onChange={e => this.update("email", e.target.value.toLowerCase())}
                    autoFocus
                  />
                  <p className="help is-danger login-form-info">{errors.email}</p>
                </Control>
                <Control className="logininput login-form-control">
                  <span className="login-form-label">Sua senha:</span>
                  <Input
                    className="login-form-input"
                    aria-label="Senha"
                    placeholder="******"
                    type="password"
                    danger={!!errors.password}
                    value={values.password}
                    onChange={e => this.update("password", e.target.value)}
                    onKeyPress={this.handleKeyPress}
                  />
                  <p className="help is-danger login-form-info">{errors.password}</p>
                </Control>
              </div>
              <div className="login-form-recover">
                <a href="https://app.aprovatotal.com.br/recuperar-senha" className="login-form-recover-help">
                  Esqueci a senha
                </a>
              </div>
              {showLoginButton ? (
                <Button
                  gradientLink
                  large
                  loading={isLogging}
                  onClick={this.doLogin}
                  type="button"
                  className="btn loginbtn">
                  <span className="loginbtn-span">ENTRAR</span>
                </Button>
              ) : null}
            </form>
          </Box>
        </div>
      </div>
    );
  }
}

LoginForm.displayName = "LoginForm";

export default LoginForm;
